import ConfirmModal from '@/components/Shared/Modal/ConfirmModal'

export default class {
  static install(Vue) {
    Vue.prototype.$confirm = (message, options = {}) => {
      const {
        body,
        onlyOk,
        okText,
        okButtonColor,
        cancelText,
        imageUrl,
      } = options
      return new Promise(resolve => {
        /* eslint-disable no-new */
        const onSuccess = () => resolve(true)
        const onFailure = () => resolve(false)

        const ConfirmModalClass = Vue.extend(ConfirmModal)
        new ConfirmModalClass({
          propsData: {
            message,
            body,
            onlyOk,
            okText,
            okButtonColor,
            cancelText,
            imageUrl,
            onSuccess,
            onFailure,
          },
        })
      })
    }
  }
}
